/** @module Auth0LanguagePacks */
import de from '../locales/extracted/de.json';
import en from '../locales/extracted/en.json';
import enAU from '../locales/extracted/en-AU.json';
import enGB from '../locales/extracted/en-GB.json';
import es from '../locales/extracted/es.json';
import fr from '../locales/extracted/fr.json';
import frCA from '../locales/extracted/fr-CA.json';
import it from '../locales/extracted/it.json';

const localDefs = {
  en: {
    displayName: 'English (US)',
    flagIcon: 'us',
    ...en,
  },
  fr: {
    displayName: 'Français',
    flagIcon: 'fr',
    ...fr,
  },
  de: {
    displayName: 'Deutsche',
    flagIcon: 'de',
    ...de,
  },
  'en-AU': {
    displayName: 'English (Australia)',
    flagIcon: 'au',
    ...enAU,
  },
  'en-GB': {
    displayName: 'English (GB)',
    flagIcon: 'gb',
    ...enGB,
  },
  es: {
    displayName: 'Español',
    flagIcon: 'es',
    ...es,
  },
  'fr-CA': {
    displayName: 'Français Canadien',
    flagIcon: 'ca',
    ...frCA,
  },
  it: {
    displayName: 'Italiano',
    flagIcon: 'it',
    ...it,
  },
};

export default localDefs;
